import { UtilityMethods } from "@mindmemobile/mm-shared-global";
import { InvoiceStatus } from "../enums";
import { IAPIRelatedInvoicesGridModel } from "../interfaces";

 
export class RelatedInvoicesGridModel {
    public id: string;
    public dueDate: Date;
    public status: keyof typeof InvoiceStatus;
    public netAmount: number;
    public paidAmount: number;
    public pastDueDays: number;
    public isPaid: boolean;
    public description: string;
    createdDate: Date;
    constructor(data: Partial<RelatedInvoicesGridModel> = {}) {
        this.id = data.id || '';
        this.dueDate = data.dueDate || new Date();
        this.status = data.status || 'Open';
        this.netAmount = data.netAmount || 0;
        this.paidAmount = data.paidAmount || 0;
        this.pastDueDays = data.pastDueDays || 0;
        this.isPaid = data.isPaid || false;
        this.description = data.description || '';
        this.createdDate = data.createdDate || new Date();
    }

    static deserializeAPIModel(data: IAPIRelatedInvoicesGridModel): RelatedInvoicesGridModel {
        const mappedData: Partial<RelatedInvoicesGridModel> = {
            id: data.id,
            dueDate: UtilityMethods.removeZFromDateString(data.dueDate),
            status: data.status as keyof typeof InvoiceStatus,
            netAmount: data.netAmount,
            pastDueDays: data.pastDueDays,
            isPaid: data.isPaid,
            paidAmount: data.paidAmount,
            description: data.description,
            createdDate: UtilityMethods.removeZFromDateString(data.createdDate),
        };

        return new RelatedInvoicesGridModel(mappedData);
    }
}
